import NavigationMenu from '../NavigationMenu.vue'
import BaseTimer from '../BaseTimer.vue'

export default {
    name: "app-bar",
    components: {
      NavigationMenu,
      BaseTimer
    },
    data() {
        return {
            isPreferredLanguage: true,
            preferredLanguage: 'tr',
            logoPath: require("../../assets/images/app-bar.png"),
            drawer: null
        }
    },
    methods: {
        logout(){
            this.$cookies.remove("authenticated");
            this.$store.dispatch('clearNavigationMenu');
            this.$store.dispatch('clearAllowedRoutes');
            this.$store.dispatch('clearUser');
            this.$router.push({
                name: 'Login'
            })
        },
        onLanguageChange(){
            if(this.isPreferredLanguage){
                this.$setLocalizationLanguage(this.preferredLanguage);
            } else {
                this.$setLocalizationLanguage('en');
            }
        },
        toggleMenu() {
          console.log('test')
          console.log(this.menu)
          this.menu = !this.menu
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/mixin/AppBar.js